import { render, staticRenderFns } from "./CustomCursor.vue?vue&type=template&id=5f2c11ad&"
import script from "./CustomCursor.vue?vue&type=script&lang=js&"
export * from "./CustomCursor.vue?vue&type=script&lang=js&"
import style0 from "./CustomCursor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports